import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";
import { type AssetAllocationFields, createAssetAllocationSchema } from "../helpers";

export type PensionFormType = AssetAllocationFields & {
  readonly investmentToolType: string;
  readonly partner?: string;
  readonly clientId: string;
  readonly fund: string;
  readonly accountState: number;
  readonly clientDeposit: number;
  readonly employerDeposit?: number;
  readonly appreciationRate: number;
  readonly strategy: string;
  readonly stateContribution?: number;
  readonly managementFee?: number;
  readonly note?: string;
  readonly horizon: number;
};

export const getPensionFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
  requireCharacteristics?: boolean,
) => ObjectSchema<PensionFormType> = (t, requireCharacteristics) => {
  return object({
    investmentToolType: string().required(t(Resources.Validation.Required)),
    partner: string().optional(),
    clientId: string().required(t(Resources.Validation.Required)),
    fund: string().required(t(Resources.Validation.Required)),
    accountState: number().required(t(Resources.Validation.Required)),
    clientDeposit: number().required(t(Resources.Validation.Required)),
    employerDeposit: number().optional(),
    appreciationRate: number().required(t(Resources.Validation.Required)),
    horizon: number().required(t(Resources.Validation.Required)),
    strategy: string().required(t(Resources.Validation.Required)),
    stateContribution: number().optional(),
    managementFee: number().optional(),
    ...createAssetAllocationSchema(t, requireCharacteristics),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
